<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{$t("message.admin.sendmail.title.history")}}</h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <div>{{$t("message.admin.sendmail.desc.history.text1")}}</div>
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="12" class="py-0">
        <div class="text-right ma-0 py-0 list-count">{{$t("message.admin.sendmail.desc.list.listCount1")}}：{{ view.list.length | addComma }}{{$t("message.admin.sendmail.desc.list.listCount2")}}</div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="view.list"
          locale="ja-jp"
          :loading-text="$t('message.admin.sendmail.desc.list.loading')"
          :no-data-text="$t('message.admin.sendmail.desc.history.noData')"
          hide-default-footer
          mobile-breakpoint=0
          class="elevation-1"
          :page.sync="view.paging.page"
          :items-per-page="view.paging.itemsPerPage"
          @page-count="view.paging.pageCount = $event"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="px-2">{{ item.sendEndDt | dateFormatter }}</td>
              <td class="px-2">{{ item.register }}</td>
              <td class="px-2">{{ item.frm }}</td>
              <td class="px-2">
                <router-link :to="'/admin/sendmail/history/detail/' + item.mailSendId">{{ item.subject }}</router-link>
              </td>
              <td class="px-2">
                <ul class="list-disc pl-5 m-0">
                  <li v-for="s in item.services" :key="s">{{ s }}</li>
                </ul>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination color="#0F9956" circle v-model="view.paging.page"
                        :length="view.paging.pageCount"></v-pagination>
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col class="text-center" cols="2">
        <mp-button wide @click="goSend">{{$t("message.admin.sendmail.button.back")}}</mp-button>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import i18n from '@/message'
import MpButton from '@/components/item/MpButton.vue'
import { AdminSendMail } from '@/api'

export default {
  components: {
    MpButton
  },
  data: () => ({
    view: {
      list: [],
      paging: {
        page: 1,
        pageCount: 5,
        itemsPerPage: 50
      }
    }
  }),
  computed: {
    headers () {
      return [
        { text: i18n.t('message.admin.sendmail.label.sendDate'), value: 'sendEndDt', sortable: false, width: 150 },
        { text: i18n.t('message.admin.sendmail.label.register'), value: 'register', sortable: false, width: 200 },
        { text: i18n.t('message.admin.sendmail.label.from'), value: 'frm', sortable: false, width: 250 },
        { text: i18n.t('message.admin.sendmail.label.subject'), value: 'subject', sortable: false, width: 300 },
        { text: i18n.t('message.admin.sendmail.label.sendConditionServices'), value: 'sendCondition', sortable: false, width: 300 }
      ]
    }
  },
  methods: {
    async getHistory () {
      this.view.list = await AdminSendMail.history()
    },
    goSend () {
      // 配信画面に戻る
      this.$router.push({ path: '/admin/sendmail' })
    }
  },
  created: async function () {
    this.getHistory()
  }
}
</script>
